import type {
  DriverActionRequest,
  DriverActionType,
  DriverRouteToday,
  DriverStop,
} from '../api/types';

export interface SessionState {
  accessToken: string;
  accessTokenExpiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
  driverName: string;
  email: string;
}

/** De schermen die de app onthoudt: de app opent op de plek waar de rit staat. */
export type PersistedScreen = 'day' | 'load' | 'ride' | 'stop' | 'return' | 'done';

/** Alle schermen, inclusief de vluchtige (scanner, uitkomst, sheets). */
export type ScreenName =
  | 'login'
  | PersistedScreen
  | 'scanner'
  | 'scanresult'
  | 'manual'
  | 'fail'
  | 'failconfirm'
  | 'queue'
  | 'settings';

export interface PersistedUiState {
  screen: PersistedScreen;
  stopId: string | null;
}

export interface Prefs {
  soundEnabled: boolean;
  iosInstallHintSeen: boolean;
  cameraPermissionAsked: boolean;
}

export const DEFAULT_PREFS: Prefs = {
  soundEnabled: true,
  iosInstallHintSeen: false,
  cameraPermissionAsked: false,
};

export type QueueItemState = 'waiting' | 'sending' | 'sent' | 'failed';

export interface QueueItem {
  clientActionId: string;
  /** Vastlegvolgorde — verzenden gebeurt hierop, want aankomst hoort vóór aflevering. */
  seq: number;
  routeId: string;
  type: DriverActionType;
  request: DriverActionRequest;
  occurredAt: string;
  state: QueueItemState;
  attempts: number;
  nextAttemptAt: number;
  /** Ondernemersnaam voor scherm J1. */
  subject: string | null;
  /** Leesbare serverreden bij "lukt niet". */
  error: string | null;
  errorCode: string | null;
  sentAt: string | null;
  /**
   * De stop zoals hij was vóór deze handeling. Alleen gevuld voor de handelingen met
   * "Toch niet? Draai terug" (B6); terugdraaien herstelt exact deze toestand.
   */
  revertStop: DriverStop | null;
}

export interface CachedRoute {
  snapshot: DriverRouteToday;
  /** Moment waarop de app de rit voor het laatst van de server haalde. */
  fetchedAt: string;
}

export interface RecordActionInput {
  type: DriverActionType;
  request: Omit<DriverActionRequest, 'clientActionId' | 'type' | 'occurredAt'> &
    Partial<Pick<DriverActionRequest, 'occurredAt'>>;
  subject?: string | null;
}
